class BannerWithCards extends HTMLElement {
  constructor() {
    super();
    this.equalizeHeights = this.equalizeHeights.bind(this);
    this.header = this.querySelector('.banner-with-cards__header');
    this.btn = this.querySelector('.banner-with-cards__main-content .mt-btn');
  }

  connectedCallback() {
    requestAnimationFrame(() => this.equalizeHeights());
    window.addEventListener('resize', this.equalizeHeights);
    this.attachListeners();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.equalizeHeights);
  }

  attachListeners() {
    if (this.btn && this.header) {
      this.btn.addEventListener('click', () => {
        window.app.dl.ctaClick(this.btn.dataset.text, { location: this.header.dataset.text || '' });
      });
    }
  }

  equalizeHeights() {
    const descriptions = this.querySelectorAll('.bwc-card__description');
    if (descriptions.length === 0) return;

    descriptions.forEach(desc => {
      desc.style.minHeight = '0px';
    });

    const maxHeight = Math.max(...Array.from(descriptions).map(desc => desc.offsetHeight));

    descriptions.forEach(desc => {
      desc.style.minHeight = `${maxHeight}px`;
    });
  }
}

customElements.define('banner-with-cards', BannerWithCards);